const navigation = () => {
  return [
    {
      title: "خانه",
      path: "/",
    },
    {
      title: "فروشگاه",
      path: "/search",
    },
    {
      title: "بلاگ",
      path: "/blog",
    },
    // {
    //   title: "آموزش خرید",
    //   path: "/guide",
    // },
    {
      title: "قوانین و مقررات",
      path: "/terms",
    },
    {
      title: "تماس باما",
      path: "/contactus",
    },
    {
      title: "سفارشات",
      path: "/orders",
    },
    {
      title: "تیکت ها",
      path: "/tickets",
    },
    // {
    //   title: "نمشی امارات",
    //   path: "/namshi",
    // },
  ];
};

export default navigation;
